import { instance2 } from "App/constants";
import { LIST_URL_MASTER } from "utils/masters";
import { defaultToastError, defaultToastSuccess, isNull } from "App/utils/helpers";
import { urlGet } from "../TabRuangAplicares/helpers";

export const urlAddKelas = LIST_URL_MASTER.kelas_rs_online.add;
export const urlUpdateKelas = LIST_URL_MASTER.kelas_rs_online.add;
export const urlUpdateKetersediaanSirsOnline = LIST_URL_MASTER.kelas_rs_online.update_ketersediaan_sirsonline;
export const urlUpdateKelasKamarSirsOnline = LIST_URL_MASTER.kelas_rs_online.update_kelas_kamar_sirsonline;
export const urlDeleteKelasKamar = LIST_URL_MASTER.kelas_rs_online.delete_kelas_kamar;
export const urlGetList = LIST_URL_MASTER.kelas_rs_online.list;
export const urlGetListReferensi = LIST_URL_MASTER.kelas_rs_online.list_referensi_kelas;
export const urlGetListAllKelasKamarSirsOnline = LIST_URL_MASTER.kelas_rs_online.list_all_kelas_kamar_sirsonline;
export const urlGetListRuangByKelasSirsOnline = LIST_URL_MASTER.ruang_rs_online.list_ruang_by_kelas_rsonline;
export const urlGetListRuangSirsOnline = LIST_URL_MASTER.ruang_rs_online.list;


export const convertDate = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

export const convertToValidListRsOL = (data, idRuangApplicares) => {
  const _temp = [];
  if (!isNull(idRuangApplicares)) {
    const ids = idRuangApplicares
      .split(",")
      .map((id) => parseInt(id.trim(), 10));

    data.forEach((item) => {
      if (ids.includes(item.id)) {
        _temp.push(item);
      }
    });
  }
  return _temp;
};

/* FOR FORM */
export const STATE_FILTER_BED = {
  search_key: "",
  pages: 1,
  limit: 10,
  // kode_ppk: process.env.REACT_APP_KODE_PPK_RUJUKAN,
};

export const RESET_STATE_SIRS_ONLINE = {
  id: "",
  name: "",
  kodebridgingsirs: "",
  remark: "-",
};

export const RESET_ROW_STATE_KETERSEDIAAN_SIRS_ONLINE = {
  id: "",
  name: "",
  remark: "",
  kodebridgingsirs: "",
  id_ruang_sirsonline: "",
}

export const PAYLOAD_KETERSEDIAAN_SIRS_ONLINE = {
  kode_kelas: "",
  nama_ruang: "",
  jumlah_ruang: "",
  jumlah: "",
  terpakai: "",
  antrian: "",
  prepare: "",
  prepare_plan: "",
  terpakai_dbd: "",
  terpakai_dbd_anak: ""
};
/* END FOR FORM */

/* FOR HEAD CELLS */
export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "kodebridgingsirs",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "KETERSEDIAAN",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsReferensiSirsOnline = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "kode_tt",
    disablePadding: true,
    label: "KODE TT",
    sort: false,
    align: "center",
    minWidth: "80px",
  },
  {
    id: "nama_tt",
    disablePadding: true,
    label: "NAMA TT",
    minWidth: "100px",
  }
];

export const headCellsAllSirsOnline = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  // {
  //   id: "act",
  //   disablePadding: true,
  //   label: "ACT",
  //   sort: false,
  //   align: "center",
  // },
  {
    id: "id_tt",
    disablePadding: false,
    label: "KODE KELAS",
    sort: false,
    align: "center",
    minWidth: "90px",
  },
  {
    id: "id_t_tt",
    disablePadding: false,
    label: "KODE RUANG",
    sort: false,
    align: "center",
    minWidth: "90px",
  },
  {
    id: "tt",
    disablePadding: false,
    label: "KELAS",
    align: "center",
    minWidth: "120px",
    sort: true,
  },
  {
    id: "ruang",
    disablePadding: false,
    label: "RUANG",
    align: "center",
    minWidth: "100px",
    sort: true,
  },
  {
    id: "jumlah_ruang",
    disablePadding: false,
    label: "JUMLAH RUANG",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH BED",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "terpakai_suspek",
    disablePadding: false,
    label: "TERPAKAI SUSPEK",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "terpakai_konfirmasi",
    disablePadding: false,
    label: "TERPAKAI KONFIRMASI",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "terpakai_dbd",
    disablePadding: false,
    label: "TERPAKAI DBD",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "terpakai_dbd_anak",
    disablePadding: false,
    label: "TERPAKAI DBD ANAK",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  // {
  //   id: "terpakai",
  //   disablePadding: false,
  //   label: "TERPAKAI",
  //   align: "center",
  //   minWidth: "120px",
  //   sort: false,
  // },
  // {
  //   id: "antrian",
  //   disablePadding: false,
  //   label: "ANTRIAN",
  //   align: "center",
  //   minWidth: "120px",
  //   sort: false,
  // },
  {
    id: "tglupdate",
    disablePadding: false,
    label: "LAST UPDATE",
    align: "center",
    minWidth: "150px",
    sort: false,
  },
];

export const headCellsKetersediaanRsOl = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "jumlah_ruang",
  //   disablePadding: false,
  //   label: "JUMLAH RUANG",
  //   align: "left",
  //   minWidth: "150px",
  // },
  // {
  //   id: "antrian",
  //   disablePadding: false,
  //   label: "ANTRIAN",
  //   align: "left",
  //   minWidth: "150px",
  // },
  {
    id: "jumlah_bed",
    disablePadding: false,
    label: "JUMLAH TT TERSEDIA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "terpakai",
    disablePadding: false,
    label: "JUMLAH TT TERPAKAI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "terpakai_dbd",
    disablePadding: false,
    label: "TERPAKAI DBD",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "terpakai_dbd_anak",
    disablePadding: false,
    label: "TERPAKAI DBD ANAK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    align: "center",
    minWidth: "150px",
  },
];
/* END FOR HEAD CELLS */

/* FOR ENDPOINT */
export const getAllSirsOnline = async () => {
  try {
    const api = await instance2.get(urlGetList);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getListRuangSirsOnline = async () => {
  try {
    const api = await instance2.get(urlGetListRuangSirsOnline);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getListRuangFromApplicare = async () => {
  try {
    const api = await instance2.get(urlGet);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getListKetersediaanSirsOL = async (id, formFilter, pages, limit) => {
  try {
    const params = {
      id_kelas: id || null
    };

    const api = await instance2.get(urlGetListRuangByKelasSirsOnline, { params });
    const res = api.data;

    if (res.status === 200) {
      return {
        state: true,
        data: res.body
      };
    } else {
      return {
        state: false,
        message: res.metaData?.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getListAllKelasSirsOL = async (formFilter, pages, limit) => {
  try {
    const params = {
      search_key: formFilter?.search_key || "",
      pages: pages || 1,
      limit: limit || 10,
    };

    const api = await instance2.get(urlGetListAllKelasKamarSirsOnline, { params });
    const res = api.data;

    if (res.status === 200) {
      return {
        state: true,
        data: res.data?.list,
        meta: {
          count: parseInt(res.meta_data.count),
        },
      };
    } else {
      return {
        state: false,
        message: res.metaData?.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getListReferensiSirsOL = async (formFilter, pages, limit) => {
  try {
    const api = await instance2.get(urlGetListReferensi);
    const res = api.data;

    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res?.metaData?.totalitems),
        },
      };
    } else {
      return {
        state: false,
        message: res.metaData?.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteSirsOnlineById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.delete(urlDeleteKelasKamar, {
      data: { id: id },
    });

    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_SIRS_ONLINE);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const updateKetersediaanSirsOnline = async (payload) => {
  try {
    const response = await instance2.put(urlUpdateKetersediaanSirsOnline, payload);

    if (response.data.status === 200) {
      return {
        state: true,
        message: response?.data?.message,
      };
    } else {
      return {
        state: false,
        message: response?.data?.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const postToServerSirsOnline = async (
  idRuangs,
  selectedData,
  stateUpdate,
  idHapus = null,
  action = "",
) => {
  try {
    const idRuangsString = idRuangs.join(", ");

    const payload = {
      id: selectedData.id,
      name: selectedData.name,
      kodebridgingsirs: selectedData.kodebridgingsirs,
      remark: selectedData.remark,
      status_update: stateUpdate ? action : "",
      id_ruangs: idRuangsString,
      ...(action === "hapus" && { id_hapus: idHapus }),
    }

    const response = await instance2.put(urlUpdateKelasKamarSirsOnline, payload)
    if (response.data.status === 200) {
      return {
        state: true,
        messgae: response?.data?.message,
      };
    } else {
      return {
        state: false,
        message: response?.data?.message,
      };
    }
  } catch (error) {
    console.error("Error posting to server:", error);
    return {
      state: false,
      message: "Terjadi kesalahan saat mengirim data ke server.",
      error: error?.message || error,
    };
  }
};
/* END FOR ENDPOINT */